import { Component, OnInit } from '@angular/core';
import { GlobalVar } from '../../globals/global-var';
import { Router } from '@angular/router';
import { HomeService } from '../../services/home.service';
import { Invite } from '../../models/invite';
import { MatDialog } from '@angular/material/dialog';
import { ReadInviteComponent } from '../teacher/invite/read-invite/read-invite.component';
import { TeacherSituation } from '../../models/teacher-situation';
import { StudentLeave } from '../../models/student-leave';
import { StudentProfile } from '../../models/student-profile';
import { Banner } from '../../models/banner';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  images = [
    '/assets/bannerImgs/廣告_SpaceIn.jpg',
    '/assets/bannerImgs/廣告_人力招募系統.jpg',
    '/assets/bannerImgs/廣告_孩童潛能開發課程.jpg',
    '/assets/bannerImgs/廣告_思無敵解題APP.jpg',
    '/assets/bannerImgs/廣告_班部助理.jpg',
    '/assets/bannerImgs/廣告_題庫協作.jpg',
    // 添加更多图片路径
  ];
  currentIndex = 0;

  studentNumber = 0;
  teacherNumber = 0;

  inviteList: Invite[] = [];

  this_month: string = "";
  teacherSituationList: TeacherSituation[] = [];

  studentLeaveList: StudentLeave[] = [];
  nonTuitionList: StudentProfile[] = [];

  bannerList: Banner[] = [];

  counter1;   //計時器

  constructor(public globalVar: GlobalVar, private router: Router, private homeService: HomeService, public dialog: MatDialog) {
    this.this_month = this.globalVar.dateAsYYYYMM(new Date());
    if (globalVar.loggedIn == false) {
      this.router.navigate(['/login']);
    }
    else {
      this.homeService.getStudentNumberApi().subscribe(
        result => {
          this.studentNumber = result.studentNumber;
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {

        }
      );
      this.homeService.getTeacherNumberApi().subscribe(
        result => {
          this.teacherNumber = result.teacherNumber;
          //alert(this.teacherNumber);
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {

        }
      );
      this.homeService.getInviteListApi().subscribe(
        result => {
          this.inviteList = result;
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {

        }
      );
      this.homeService.getTeacherSituationListApi(this.this_month).subscribe(
        result => {
          this.teacherSituationList = result;
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {

        }
      );
      this.homeService.getStudentLeaveListApi(this.this_month).subscribe(
        result => {
          this.studentLeaveList = result;
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {

        }
      );
      this.homeService.getNonTuitionListApi(this.this_month).subscribe(
        result => {
          this.nonTuitionList = result;
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {

        }
      );
      this.homeService.getBannerApi().subscribe(
        result => {
          this.bannerList = result;
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {

        }
      );
    }


    this.globalVar.mzPadding = "0";
  }

  ngOnInit(): void {
    this.counter1 = setInterval(() => {
      this.nextImage();
    }, 6000); // 图片每3秒切换一次
  }

  ngOnDestroy(): void {
    clearInterval(this.counter1);
    this.globalVar.mzPadding = "5px 20px";
  }



  setCurrentIndex(index: number) {
    this.currentIndex = index;
  }

  prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.bannerList.length - 1;
    }
  }

  nextImage() {
    if (this.currentIndex < this.bannerList.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }


  //查詢
  openReadDialog(invite: Invite) {
    const dialogRef = this.dialog.open(ReadInviteComponent, { data: { invite: invite }, disableClose: false, hasBackdrop: true, width: '1080px', maxWidth: '90vw', height: '100vh', maxHeight: '100vh' }); //disableClose只能透過關閉紐關閉，hasBackdrop背景鎖定
    dialogRef.updatePosition({
      right: '0px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "callback") {
        
      }
    });
  }

}
